import { atom } from 'infrastructure/state/jotai.wrapper'
import { parseSheetForConfig } from 'infrastructure/googleDrive'
import { ScopeAndSequence, ScopeAndSequenceRow, SheetDataRow } from './types'

const config = [
  { header: 'Grade' },
  { header: 'Unit Number' },
  { header: 'Unit Name' },
  { header: 'Standard' },
]

export const currentSheetRawDataAtom = atom<string[][]>()

export const currentSpreadsheetIdAtom = atom<string | undefined>(undefined)

export const parsedSheetDataAtom = atom((get) => {
  const rawData = get(currentSheetRawDataAtom)
  if (!rawData) return
  const parsed = parseSheetForConfig<SheetDataRow>(rawData, config)
  return convertToScopeAndSequence(parsed)
})

export const sheetDataForTable = atom((get) => {
  const data = get(parsedSheetDataAtom)
  if (!data) return
  return data.reduce<ScopeAndSequenceRow[]>((acc, gradeData) => {
    const { grade, units } = gradeData
    units.forEach((unit) => {
      const { name, unitNumber, standards } = unit
      standards.forEach((standard) => {
        acc.push({
          grade,
          standard,
          unitName: name,
          unitNumber,
        })
      })
    })
    return acc
  }, [])
})

export function convertToScopeAndSequence(
  rows: SheetDataRow[],
): ScopeAndSequence[] {
  const gradesMap = rows.reduce<
    Map<
      string,
      Map<string, { name: string; standards: Set<string>; unitNumber: number }>
    >
  >((acc, row) => {
    if (!acc.has(row.grade)) {
      acc.set(row.grade, new Map())
    }
    const unitsMap = acc.get(row.grade)!

    if (!unitsMap.has(row.unitNumber)) {
      unitsMap.set(row.unitNumber, {
        name: row.unitName,
        standards: new Set(),
        unitNumber: Number(row.unitNumber),
      })
    }
    if (row.standard) {
      unitsMap.get(row.unitNumber)!.standards.add(row.standard)
    }
    return acc
  }, new Map())

  return Array.from(gradesMap.entries()).map(([grade, unitsMap]) => ({
    grade: Number(grade),
    units: Array.from(unitsMap.entries())
      .sort(([a], [b]) => Number(a) - Number(b)) // sort units numerically
      .map(([, unit]) => ({
        name: unit.name,
        unitNumber: unit.unitNumber,
        standards: Array.from(unit.standards),
      })),
  }))
}
